import { GraphicsPage } from './pages';

export const graphicsRoutes = [
  {
    path: 'graphics',
    component: GraphicsPage,
    requiredPermission: 'graphics.view',
  },
];
